import { useState } from "react";
import {
  pagamentoOnlineService,
  CEPData,
} from "../services/PagamentoOnlineService";

interface UseCEPSearchReturn {
  isLoading: boolean;
  error: string | null;
  buscarCEP: (cep: string) => Promise<CEPData | null>;
  buscarEstados: () => Promise<any[] | null>;
  buscarCidades: (idEstado: number) => Promise<any[] | null>;
  limparErro: () => void;
}

export const useCEPSearch = (): UseCEPSearchReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const buscarCEP = async (cep: string): Promise<CEPData | null> => {
    if (!cep.trim()) {
      setError("CEP é obrigatório");
      return null;
    }

    // Valida formato do CEP
    if (!pagamentoOnlineService.validarCEP(cep)) {
      setError("CEP deve ter 8 dígitos");
      return null;
    }

    setIsLoading(true);
    setError(null);

    try {
      const resultado = await pagamentoOnlineService.buscarCEP(cep);

      if (resultado.success && resultado.data) {
        return resultado.data;
      } else {
        setError(resultado.error || "Erro ao buscar CEP");
        return null;
      }
    } catch (err) {
      setError("Erro inesperado ao buscar CEP");
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const buscarEstados = async (): Promise<any[] | null> => {
    const resultado = await pagamentoOnlineService.buscarEstados();

    //formata para retornar label e value
    const resultadoFormatado = resultado?.map((item: any) => ({
      label: item.nome,
      value: item.id,
      uf: item.sigla,
    }));

    return resultadoFormatado || [];
  };

  const buscarCidades = async (idEstado: number): Promise<any[] | null> => {
    const resultado = await pagamentoOnlineService.buscarCidades(idEstado);

    //formata para retornar label e value
    const resultadoFormatado = resultado?.map((item: any) => ({
      label: item.nome,
      value: item.id,
    }));
    return resultadoFormatado || [];
  };

  const limparErro = () => {
    setError(null);
  };

  return {
    isLoading,
    error,
    buscarCEP,
    buscarEstados,
    buscarCidades,
    limparErro,
  };
};
